import React, {useContext} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {View, StyleSheet, Button, Text, TouchableOpacity, Platform} from 'react-native';

import {I18nContext} from 'i18n/context/I18nContext';
import recordError from './recordError';
import LottieAnimation from 'components/animations/LottieAnimation';
import WorkingAnimation from 'components/animations/scenes/WorkingAnimation';

import { TYPE, FONTS } from 'style/typography';

const ANIMATION_HEIGHT = 300;

const errorHandler = (error) => {
  recordError(error);
};

const ErrorFallback = ({resetErrorBoundary}) => {
  const {translate} = useContext(I18nContext);

  return (
    <View style={[styles.container]}>
      <LottieAnimation
        source={WorkingAnimation}
        style={[styles.animationView]}
        webHeight={ANIMATION_HEIGHT}
        autoPlay
      />

      <View>
        <Text style={styles.errorMessageText}>
          {translate('errorHandler.wrong')}
        </Text>
        {Platform.OS === 'web' ? (
          // React Native Web's Button cannot take the app font; this is its exact look with the app font. Native keeps
          // the platform Button.
          <TouchableOpacity
            accessibilityRole="button"
            style={styles.retryButton}
            onPress={resetErrorBoundary}>
            <Text style={styles.retryText}>{translate('errorHandler.tryAgain')}</Text>
          </TouchableOpacity>
        ) : (
          <Button
            title={translate('errorHandler.tryAgain')}
            onPress={resetErrorBoundary}
          />
        )}
      </View>
    </View>
  );
};

export const ErrorHandler = ({children}) => (
  <ErrorBoundary FallbackComponent={ErrorFallback} onError={errorHandler}>
    {children}
  </ErrorBoundary>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 12,
  },
  animationView: {
    height: ANIMATION_HEIGHT,
  },
  // React Native Web's Button styles (react-native-web/dist/exports/Button), plus the app font
  retryButton: {
    backgroundColor: '#2196F3',
    borderRadius: 2,
  },
  retryText: {
    color: '#fff',
    fontSize: TYPE.sm,
    fontFamily: FONTS.body,
    fontWeight: '600',
    padding: 8,
    textAlign: 'center',
  },
  errorMessageText: {
    fontSize: TYPE['2xl'],
    fontFamily: FONTS.body,
    marginBottom: 10,
  },
});
